import React, {useEffect, useState} from "react";
import axios from "axios";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ";
function AdminWorkTasks() {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const fetchAssignments = async () => {
        try {
            setIsLoading(true);
            const reqRes = await axios.get(
                baseUrl + "requirements/"
            );
            const requirements = reqRes.data;
            let allAssignments = [];
            for (const req of requirements) {
                const assignRes = await axios.get(
                    baseUrl +
                    "assignment-requirement/" +
                    req.id +
                    "/"
                );
                allAssignments = [
                    ...allAssignments,
                    ...assignRes.data
                ];
            }
            const formattedRows =
                allAssignments.map((item, index) => ({
                    id: item.id,
                    sno: index + 1,
                    worker_name:
                    item.worker?.name,
                    worker_mobile:
                    item.worker?.mobile,
                    crop_type:
                    item.requirement?.crop_type,
                    location:
                    item.requirement?.location,
                    pincode:
                    item.requirement?.pincode,
                    owner_name:
                    item.requirement?.owner?.name,
                    owner_mobile:
                    item.requirement?.owner?.mobile,
                    land_size:
                        `${item.requirement?.land_size}
             ${item.requirement?.land_unit}`,
                    budget:
                    item.requirement?.budget,
                    present_days:
                    item.total_present_days,
                    amount_earned:
                    item.total_amount,
                    status:
                    item.status,
                    raw: item
                }));
            setRows(formattedRows);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchAssignments();
    }, []);
    const deleteAssignment = async (id) => {
        const result = await Swal.fire({
            title: "Delete Assignment?",
            text: "This cannot be undone",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        });
        if (!result.isConfirmed) return;
        try {
            await axios.delete(
                baseUrl +
                "delete-assignment/" +
                id +
                "/"
            );
            Swal.fire(
                "Deleted",
                "Assignment removed",
                "success"
            );
            fetchAssignments();
        } catch (err) {
            console.log(err);
            Swal.fire(
                "Error",
                "Unable to delete",
                "error"
            );
        }
    };
    const columns = [
        {
            field: "sno",
            headerName: "S.No",
            width: 80
        },
        {
            field: "worker_name",
            headerName: "Worker",
            width: 180
        },
        {
            field: "worker_mobile",
            headerName: "Worker Mobile",
            width: 150
        },
        {
            field: "crop_type",
            headerName: "Crop",
            width: 150
        },
        {
            field: "location",
            headerName: "Location",
            width: 150
        },
        {
            field: "pincode",
            headerName: "Pincode",
            width: 120
        },
        {
            field: "owner_name",
            headerName: "Owner",
            width: 180
        },
        {
            field: "owner_mobile",
            headerName: "Owner Mobile",
            width: 150
        },
        {
            field: "land_size",
            headerName: "Land Size",
            width: 150
        },
        {
            field: "budget",
            headerName: "Budget",
            width: 120
        },
        {
            field: "present_days",
            headerName: "Present Days",
            width: 130
        },
        {
            field: "amount_earned",
            headerName: "Earned",
            width: 130
        },
        {
            field: "status",
            headerName: "Status",
            width: 120
        },
        {
            field: "action",
            headerName: "Action",
            width: 150,
            renderCell: (params) => (
                <button
                    className="btn btn-danger btn-sm"
                    onClick={() =>
                        deleteAssignment(
                            params.row.id
                        )
                    }
                >
                    Delete
                </button>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="page-header mb-4">

                <h3>
                    All Work Assignments
                </h3>

                <small>
                    Admin View - All Assigned Tasks
                </small>

            </div>

            <ERPDataGrid
                sx={{
                    boxShadow: 4,
                    border: 2,
                    borderColor: "primary.light",
                    "& .MuiDataGrid-cell:hover": {
                        color: "primary.main",
                    },
                }}
                className="mt-4"
                rows={rows}
                columns={columns}

                autoHeight
                loading={isLoading}
                pageSizeOptions={[10, 25, 50, 100]}
            />

        </section>
    );
}
export default AdminWorkTasks;